import { useEffect, useState } from 'react'

// Viewport-width "is this a narrow (phone) screen" hook. Tracks the SAME 768px breakpoint the
// CSS uses for the mobile layout (sidebar overlay, panel host fullscreen vs side column). Unlike
// IS_MOBILE (userAgent, computed once), this reacts to resize/rotate so the panel host can switch
// between split-screen (desktop) and full-screen-swap (mobile) live. See PLUGIN_MODULES.md.
const QUERY = '(max-width: 768px)'

export function useIsNarrow(): boolean {
  const [narrow, setNarrow] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches,
  )
  useEffect(() => {
    if (typeof window === 'undefined') return
    const mq = window.matchMedia(QUERY)
    const onChange = () => setNarrow(mq.matches)
    onChange() // sync in case it changed between first render and effect
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])
  return narrow
}
